/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessPayload,
  AddContactsPayload,
  AddContactsResponse,
  AddSingleContactResponse,
  ApproveReissueResponse,
  BodyCandidatesAddSingleContact,
  BodyCandidatesExtractResumeContactFields,
  BodyCandidatesUploadCandidateCsv,
  BodyCandidatesUploadCandidateResumesPreview,
  BulkProceedToInterviewPayload,
  BulkProceedToInterviewResponse,
  BulkReissueInterviewPayload,
  BulkReissueInterviewResponse,
  BulkResumeImportItemsPage,
  BulkResumeImportStatusResponse,
  CallDetailsResponse,
  CandidateCallAvailabilityResponse,
  CandidateCallCoreResponse,
  CandidateCallHistoryResponse,
  CandidateCallRecommendationsResponse,
  CandidateCallReviewResponse,
  CandidateCallSectionsResponse,
  CandidateCampaignAccessResponse,
  CandidateCampaignAccessUpdatedResponse,
  CandidateCampaignCommentView,
  CandidateCampaignFeedbackResponse,
  CandidateCampaignFeedbackUpdatedResponse,
  CandidatePayload,
  CandidateSourceResponse,
  CandidateTranscriptSharingContextResponse,
  CandidatesCandidateApiUpdateSubmittalReportPayload,
  CandidatesCandidatesByIdentifierParams,
  CandidatesGetCandidateCallSectionsParams,
  CandidatesListBulkResumeImportItemsParams,
  CandidatesPreviewBulkResumeImportParams,
  ChatWithTranscriptPayload,
  CheckRecentUploadsResponse,
  CloseRecentUploadsResponse,
  CommentActionResponse,
  CommentCountResponse,
  CommentRequest,
  ContactPreviewPayload,
  ContactPreviewResponse,
  CreateBulkResumeImportRequest,
  CreateBulkResumeImportResult,
  CsvUploadResponse,
  ExtractResumeContactFieldsResponse,
  FeedbackRequest,
  InternalAddCandidateResponse,
  InterviewReissueRequestPayload,
  InterviewReissueRequestResponse,
  MessageResponse,
  MultiCandidateTranscriptChatPayload,
  PrepareChatContextPayload,
  PrepareChatContextResponse,
  PriorInterviewsResponse,
  ProceedToInterviewResponse,
  ReissueInterviewResponse,
  RejectReissueResponse,
  RemoveCandidateResponse,
  ResumeUrlResponse,
  ReviewChangesPayload,
  SavedCandidateCommentResponse,
  ScheduleNextInterviewPayload,
  ScheduleNextInterviewResponse,
  SendCandidateSmsPayload,
  SendCandidateSmsResponse,
  SmsDetailsResponse,
  SubmittalReportResponse,
  TranscriptChatResponse,
  TranslateTextsPayload,
  TranslateTextsResponse,
  UpdateCommentRequest,
  UploadCandidateResumesPreviewResponse,
  UploadContactsToJobsPayload,
  UploadContactsToJobsPreviewPayload,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getCandidates = () => {
  /**
   * @summary Update Candidate Campaign User Reviewed
   */
  const candidatesUpdateCandidateCampaignUserReviewed = (
    candidateId: string,
    campaignId: string,
    reviewChangesPayload: ReviewChangesPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/candidate/${candidateId}/review_changes/${campaignId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reviewChangesPayload,
      },
      options
    );
  };
  /**
   * @summary Mark Changes Unreviewed
   */
  const candidatesMarkChangesUnreviewed = (
    candidateId: string,
    campaignId: string,
    reviewChangesPayload: ReviewChangesPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/candidate/${candidateId}/unreview_changes/${campaignId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reviewChangesPayload,
      },
      options
    );
  };
  /**
   * @summary Get Call Details
   */
  const candidatesGetCallDetails = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CallDetailsResponse>>
  ) => {
    return axiosInstance<CallDetailsResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/call_details`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Resume Url
   */
  const candidatesGetResumeUrl = (
    candidateId: string,
    options?: SecondParameter<typeof axiosInstance<ResumeUrlResponse>>
  ) => {
    return axiosInstance<ResumeUrlResponse>(
      { url: `/candidate/${candidateId}/resume_url`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Pause Candidate
   */
  const candidatesPauseCandidate = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/pause`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * @summary Resume Candidate
   */
  const candidatesResumeCandidate = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/resume`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Remove a candidate from campaign by setting deleted to true
   * @summary Remove Candidate
   */
  const candidatesRemoveCandidate = (
    candidateCampaignId: string,
    options?: SecondParameter<typeof axiosInstance<RemoveCandidateResponse>>
  ) => {
    return axiosInstance<RemoveCandidateResponse>(
      { url: `/candidate/${candidateCampaignId}/remove`, method: 'POST' },
      options
    );
  };
  /**
   * Pre-fetch and cache all chat context data so subsequent messages skip data fetching.
   * @summary Prepare Chat Context Endpoint
   */
  const candidatesPrepareChatContextEndpoint = (
    prepareChatContextPayload: PrepareChatContextPayload,
    options?: SecondParameter<typeof axiosInstance<PrepareChatContextResponse>>
  ) => {
    return axiosInstance<PrepareChatContextResponse>(
      {
        url: `/candidate_chat/prepare`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: prepareChatContextPayload,
      },
      options
    );
  };
  /**
   * @summary Candidate Transcript Chat
   */
  const candidatesCandidateTranscriptChat = (
    chatWithTranscriptPayload: ChatWithTranscriptPayload,
    options?: SecondParameter<typeof axiosInstance<TranscriptChatResponse>>
  ) => {
    return axiosInstance<TranscriptChatResponse>(
      {
        url: `/candidate_transcript_chat`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: chatWithTranscriptPayload,
      },
      options
    );
  };
  /**
 * Process and analyze multiple candidate transcripts at once.
This endpoint accepts a list of candidate IDs and returns insights across all candidates.
 * @summary Multi Candidate Chat With Transcript
 */
  const candidatesMultiCandidateChatWithTranscript = (
    multiCandidateTranscriptChatPayload: MultiCandidateTranscriptChatPayload,
    options?: SecondParameter<typeof axiosInstance<TranscriptChatResponse>>
  ) => {
    return axiosInstance<TranscriptChatResponse>(
      {
        url: `/transcript/multi_candidate_transcript_chat`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: multiCandidateTranscriptChatPayload,
      },
      options
    );
  };
  /**
   * Schedule a next interview for a candidate.
   * @summary Schedule Next Interview Over Sms
   */
  const candidatesScheduleNextInterviewOverSms = (
    candidateId: string,
    campaignId: string,
    scheduleNextInterviewPayload: ScheduleNextInterviewPayload,
    options?: SecondParameter<
      typeof axiosInstance<ScheduleNextInterviewResponse>
    >
  ) => {
    return axiosInstance<ScheduleNextInterviewResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/schedule_next_interview_over_sms`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: scheduleNextInterviewPayload,
      },
      options
    );
  };
  /**
 * Send an ad-hoc text to a candidate on the SMS or WhatsApp thread.

SMS goes from the candidate/campaign's most recent call number; WhatsApp from the
candidate's WhatsApp sender, and only inside WhatsApp's 24-hour reply window.

Note: This endpoint is currently primarily used by a support-only frontend feature, but it is a
normal authenticated endpoint so we can expose it to users later.
 * @summary Send Sms To Candidate
 */
  const candidatesSendSmsToCandidate = (
    candidateId: string,
    campaignId: string,
    sendCandidateSmsPayload: SendCandidateSmsPayload,
    options?: SecondParameter<typeof axiosInstance<SendCandidateSmsResponse>>
  ) => {
    return axiosInstance<SendCandidateSmsResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/send_sms`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendCandidateSmsPayload,
      },
      options
    );
  };
  /**
   * Updates the entry in the candidate views table
   * @summary Update Candidate View
   */
  const candidatesUpdateCandidateView = (
    candidateId: string,
    options?: SecondParameter<typeof axiosInstance<void>>
  ) => {
    return axiosInstance<void>(
      { url: `/candidate/${candidateId}/view`, method: 'POST' },
      options
    );
  };
  /**
 * Core single-candidate call details required for the transcript drawer's first paint.

Also serves an archived job's interview history, read-only, to callers with VIEW on it.
 * @summary Get Candidate Call Details
 */
  const candidatesGetCandidateCallDetails = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CandidateCallCoreResponse>>
  ) => {
    return axiosInstance<CandidateCallCoreResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Call Availability
   */
  const candidatesGetCandidateCallAvailability = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCallAvailabilityResponse>
    >
  ) => {
    return axiosInstance<CandidateCallAvailabilityResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}/availability`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Call History
   */
  const candidatesGetCandidateCallHistory = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCallHistoryResponse>
    >
  ) => {
    return axiosInstance<CandidateCallHistoryResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}/history`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Call Review
   */
  const candidatesGetCandidateCallReview = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CandidateCallReviewResponse>>
  ) => {
    return axiosInstance<CandidateCallReviewResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}/review`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Call Recommendations
   */
  const candidatesGetCandidateCallRecommendations = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCallRecommendationsResponse>
    >
  ) => {
    return axiosInstance<CandidateCallRecommendationsResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}/recommendations`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Several lazy drawer sections from one load of the candidate, calls and cci.
   * @summary Get Candidate Call Sections
   */
  const candidatesGetCandidateCallSections = (
    candidateId: string,
    campaignId: string,
    params: CandidatesGetCandidateCallSectionsParams,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCallSectionsResponse>
    >
  ) => {
    return axiosInstance<CandidateCallSectionsResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}/sections`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
   * @summary Get Candidate Prior Interviews
   */
  const candidatesGetCandidatePriorInterviews = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<PriorInterviewsResponse>>
  ) => {
    return axiosInstance<PriorInterviewsResponse>(
      {
        url: `/candidate/${candidateId}/call_details/${campaignId}/prior_interviews`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Sms Details
   */
  const candidatesGetCandidateSmsDetails = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<SmsDetailsResponse>>
  ) => {
    return axiosInstance<SmsDetailsResponse>(
      {
        url: `/candidate/${candidateId}/sms_details/${campaignId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Campaign Feedback
   */
  const candidatesGetCandidateCampaignFeedback = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCampaignFeedbackResponse>
    >
  ) => {
    return axiosInstance<CandidateCampaignFeedbackResponse>(
      {
        url: `/candidate/${candidateId}/feedback/${campaignId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Candidate Campaign Feedback
   */
  const candidatesCandidateCampaignFeedback = (
    candidateId: string,
    campaignId: string,
    feedbackRequest: FeedbackRequest,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCampaignFeedbackUpdatedResponse>
    >
  ) => {
    return axiosInstance<CandidateCampaignFeedbackUpdatedResponse>(
      {
        url: `/candidate/${candidateId}/feedback/${campaignId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: feedbackRequest,
      },
      options
    );
  };
  /**
 * Public preflight for a shared transcript link.

Only a pair an anonymous viewer may read answers UNRESTRICTED. Every other pair answers
RESTRICTED alike, so the response never tells a real candidate/job pair from an invented one.
 * @summary Get Candidate Campaign Access
 */
  const candidatesGetCandidateCampaignAccess = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCampaignAccessResponse>
    >
  ) => {
    return axiosInstance<CandidateCampaignAccessResponse>(
      {
        url: `/candidate-access/${candidateId}/campaign/${campaignId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Resolve staff navigation and sharing controls without exposing an org identifier.
   * @summary Get Transcript Sharing Context
   */
  const candidatesGetTranscriptSharingContext = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateTranscriptSharingContextResponse>
    >
  ) => {
    return axiosInstance<CandidateTranscriptSharingContextResponse>(
      {
        url: `/transcript-sharing-context/${candidateId}/campaign/${campaignId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Set Candidate Campaign Access
   */
  const candidatesSetCandidateCampaignAccess = (
    candidateId: string,
    campaignId: string,
    accessPayload: AccessPayload,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCampaignAccessUpdatedResponse>
    >
  ) => {
    return axiosInstance<CandidateCampaignAccessUpdatedResponse>(
      {
        url: `/candidate/${candidateId}/access/${campaignId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: accessPayload,
      },
      options
    );
  };
  /**
   * @summary Translate Transcript
   */
  const candidatesTranslateTranscript = (
    translateTextsPayload: TranslateTextsPayload,
    options?: SecondParameter<typeof axiosInstance<TranslateTextsResponse>>
  ) => {
    return axiosInstance<TranslateTextsResponse>(
      {
        url: `/translate_transcript`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: translateTextsPayload,
      },
      options
    );
  };
  /**
   * @summary Candidates By Identifier
   */
  const candidatesCandidatesByIdentifier = (
    params?: CandidatesCandidatesByIdentifierParams,
    options?: SecondParameter<typeof axiosInstance<CandidateSourceResponse[]>>
  ) => {
    return axiosInstance<CandidateSourceResponse[]>(
      { url: `/candidates_by_identifier`, method: 'GET', params },
      options
    );
  };
  /**
   * @summary Get Submittal Report
   */
  const candidatesGetSubmittalReport = (
    candidateId: string,
    campaignId: string,
    callId: string,
    options?: SecondParameter<typeof axiosInstance<SubmittalReportResponse>>
  ) => {
    return axiosInstance<SubmittalReportResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/call/${callId}/submittal_report`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Update Submittal Report
   */
  const candidatesUpdateSubmittalReport = (
    candidateId: string,
    campaignId: string,
    callId: string,
    candidatesCandidateApiUpdateSubmittalReportPayload: CandidatesCandidateApiUpdateSubmittalReportPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/call/${callId}/submittal_report/edit`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: candidatesCandidateApiUpdateSubmittalReportPayload,
      },
      options
    );
  };
  /**
   * @summary Add Contacts Preview
   */
  const candidatesAddContactsPreview = (
    campaignId: string,
    contactPreviewPayload: ContactPreviewPayload,
    options?: SecondParameter<typeof axiosInstance<ContactPreviewResponse>>
  ) => {
    return axiosInstance<ContactPreviewResponse>(
      {
        url: `/campaigns/edit/${campaignId}/add_contacts_preview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: contactPreviewPayload,
      },
      options
    );
  };
  /**
   * Extract candidate contact details from a resume for manual add-contact autofill.
   * @summary Extract Resume Contact Fields
   */
  const candidatesExtractResumeContactFields = (
    campaignId: string,
    bodyCandidatesExtractResumeContactFields: BodyCandidatesExtractResumeContactFields,
    options?: SecondParameter<
      typeof axiosInstance<ExtractResumeContactFieldsResponse>
    >
  ) => {
    const formData = new FormData();
    formData.append(
      `resume_file`,
      bodyCandidatesExtractResumeContactFields.resume_file
    );

    return axiosInstance<ExtractResumeContactFieldsResponse>(
      {
        url: `/campaigns/edit/${campaignId}/extract_resume_contact_fields`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
   * Endpoint to finalize and add contacts to the campaign.
   * @summary Add Contacts
   */
  const candidatesAddContacts = (
    campaignId: string,
    addContactsPayload: AddContactsPayload,
    options?: SecondParameter<typeof axiosInstance<AddContactsResponse>>
  ) => {
    return axiosInstance<AddContactsResponse>(
      {
        url: `/campaigns/edit/${campaignId}/add_contacts`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addContactsPayload,
      },
      options
    );
  };
  /**
   * Preview multi-job CSV upload (resolve jobs, check permissions, validate contacts).
   * @summary Upload Contacts To Jobs Preview
   */
  const candidatesUploadContactsToJobsPreview = (
    uploadContactsToJobsPreviewPayload: UploadContactsToJobsPreviewPayload,
    options?: SecondParameter<typeof axiosInstance<ContactPreviewResponse>>
  ) => {
    return axiosInstance<ContactPreviewResponse>(
      {
        url: `/candidates/upload_to_jobs_preview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: uploadContactsToJobsPreviewPayload,
      },
      options
    );
  };
  /**
   * Add contacts from a multi-job CSV to their resolved jobs.
   * @summary Upload Contacts To Jobs
   */
  const candidatesUploadContactsToJobs = (
    uploadContactsToJobsPayload: UploadContactsToJobsPayload,
    options?: SecondParameter<typeof axiosInstance<AddContactsResponse>>
  ) => {
    return axiosInstance<AddContactsResponse>(
      {
        url: `/candidates/upload_to_jobs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: uploadContactsToJobsPayload,
      },
      options
    );
  };
  /**
 * Add a single contact to a campaign with optional resume upload.
Used by the manual "Enter Contact Details Manually" form.
 * @summary Add Single Contact
 */
  const candidatesAddSingleContact = (
    campaignId: string,
    bodyCandidatesAddSingleContact: BodyCandidatesAddSingleContact,
    options?: SecondParameter<typeof axiosInstance<AddSingleContactResponse>>
  ) => {
    const formData = new FormData();
    formData.append(`name`, bodyCandidatesAddSingleContact.name);
    if (
      bodyCandidatesAddSingleContact.phone !== undefined &&
      bodyCandidatesAddSingleContact.phone !== null
    ) {
      formData.append(`phone`, bodyCandidatesAddSingleContact.phone);
    }
    if (
      bodyCandidatesAddSingleContact.email !== undefined &&
      bodyCandidatesAddSingleContact.email !== null
    ) {
      formData.append(`email`, bodyCandidatesAddSingleContact.email);
    }
    if (
      bodyCandidatesAddSingleContact.timezone !== undefined &&
      bodyCandidatesAddSingleContact.timezone !== null
    ) {
      formData.append(`timezone`, bodyCandidatesAddSingleContact.timezone);
    }
    if (
      bodyCandidatesAddSingleContact.zipcode !== undefined &&
      bodyCandidatesAddSingleContact.zipcode !== null
    ) {
      formData.append(`zipcode`, bodyCandidatesAddSingleContact.zipcode);
    }
    if (bodyCandidatesAddSingleContact.contact_source !== undefined) {
      formData.append(
        `contact_source`,
        bodyCandidatesAddSingleContact.contact_source
      );
    }
    if (
      bodyCandidatesAddSingleContact.resume_file !== undefined &&
      bodyCandidatesAddSingleContact.resume_file !== null
    ) {
      formData.append(
        `resume_file`,
        bodyCandidatesAddSingleContact.resume_file
      );
    }

    return axiosInstance<AddSingleContactResponse>(
      {
        url: `/campaigns/edit/${campaignId}/add_single_contact`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
 * Endpoint wrapper for add_candidate_internal.
Creates/updates a candidate and optionally adds them to a campaign.

Expected rejections are 4xx (403 when adding candidates is disabled; 400 for a missing
org context, raised by add_candidate_internal, or an identity field longer than its
column). Anything else reaches the global handler
as a logged 500, so callers retry instead of treating an outage as a bad request.
 * @summary Internal Add Candidate
 */
  const candidatesInternalAddCandidate = (
    candidatePayload: CandidatePayload,
    options?: SecondParameter<
      typeof axiosInstance<InternalAddCandidateResponse>
    >
  ) => {
    return axiosInstance<InternalAddCandidateResponse>(
      {
        url: `/internal/add_candidate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidatePayload,
      },
      options
    );
  };
  /**
   * Extract contact rows from uploaded resume files for Add Contacts bulk preview flow.
   * @summary Upload Candidate Resumes Preview
   */
  const candidatesUploadCandidateResumesPreview = (
    campaignId: string,
    bodyCandidatesUploadCandidateResumesPreview: BodyCandidatesUploadCandidateResumesPreview,
    options?: SecondParameter<
      typeof axiosInstance<UploadCandidateResumesPreviewResponse>
    >
  ) => {
    const formData = new FormData();
    formData.append(
      `accepts_email`,
      bodyCandidatesUploadCandidateResumesPreview.accepts_email.toString()
    );
    bodyCandidatesUploadCandidateResumesPreview.resume_files.forEach((value) =>
      formData.append(`resume_files`, value)
    );

    return axiosInstance<UploadCandidateResumesPreviewResponse>(
      {
        url: `/campaigns/edit/${campaignId}/upload_candidate_resumes_preview`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
 * Start an async bulk resume ZIP import and return a write-scoped upload URL.

The client PUTs the archive to `upload_url`, then calls the `/complete` endpoint.
 * @summary Create Bulk Resume Import
 */
  const candidatesCreateBulkResumeImport = (
    campaignId: string,
    createBulkResumeImportRequest: CreateBulkResumeImportRequest,
    options?: SecondParameter<
      typeof axiosInstance<CreateBulkResumeImportResult>
    >
  ) => {
    return axiosInstance<CreateBulkResumeImportResult>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_resume_imports`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createBulkResumeImportRequest,
      },
      options
    );
  };
  /**
   * Confirm the ZIP upload finished and queue background extraction.
   * @summary Complete Bulk Resume Import Upload
   */
  const candidatesCompleteBulkResumeImportUpload = (
    campaignId: string,
    importId: string,
    options?: SecondParameter<
      typeof axiosInstance<BulkResumeImportStatusResponse>
    >
  ) => {
    return axiosInstance<BulkResumeImportStatusResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_resume_imports/${importId}/complete`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Progress and counts for one bulk resume import.
   * @summary Get Bulk Resume Import
   */
  const candidatesGetBulkResumeImport = (
    campaignId: string,
    importId: string,
    options?: SecondParameter<
      typeof axiosInstance<BulkResumeImportStatusResponse>
    >
  ) => {
    return axiosInstance<BulkResumeImportStatusResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_resume_imports/${importId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Page through the per-resume rows of a bulk resume import.
   * @summary List Bulk Resume Import Items
   */
  const candidatesListBulkResumeImportItems = (
    campaignId: string,
    importId: string,
    params?: CandidatesListBulkResumeImportItemsParams,
    options?: SecondParameter<typeof axiosInstance<BulkResumeImportItemsPage>>
  ) => {
    return axiosInstance<BulkResumeImportItemsPage>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_resume_imports/${importId}/items`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
 * Add-contacts review payload for a completed bulk resume import.

Same shape as the synchronous resume upload preview; available once the import is READY.
 * @summary Preview Bulk Resume Import
 */
  const candidatesPreviewBulkResumeImport = (
    campaignId: string,
    importId: string,
    params: CandidatesPreviewBulkResumeImportParams,
    options?: SecondParameter<
      typeof axiosInstance<UploadCandidateResumesPreviewResponse>
    >
  ) => {
    return axiosInstance<UploadCandidateResumesPreviewResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_resume_imports/${importId}/preview`,
        method: 'POST',
        params,
      },
      options
    );
  };
  /**
 * Endpoint to upload a candidate CSV file to Azure Blob Storage.
The file is stored in the candidate CSV container with a unique name.

The blob is attributed to the session user. The ``user_id`` form field is still accepted
because older clients send it, but it is ignored: the session decides the user.
 * @summary Upload Candidate Csv
 */
  const candidatesUploadCandidateCsv = (
    bodyCandidatesUploadCandidateCsv: BodyCandidatesUploadCandidateCsv,
    options?: SecondParameter<typeof axiosInstance<CsvUploadResponse>>
  ) => {
    const formData = new FormData();
    formData.append(`file`, bodyCandidatesUploadCandidateCsv.file);
    if (
      bodyCandidatesUploadCandidateCsv.user_id !== undefined &&
      bodyCandidatesUploadCandidateCsv.user_id !== null
    ) {
      formData.append(`user_id`, bodyCandidatesUploadCandidateCsv.user_id);
    }

    return axiosInstance<CsvUploadResponse>(
      {
        url: `/upload_candidate_csv`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
   * Read durable upload progress; absence is distinct from a failed status read.
   * @summary Check Recently Uploaded Candidates
   */
  const candidatesCheckRecentlyUploadedCandidates = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CheckRecentUploadsResponse>>
  ) => {
    return axiosInstance<CheckRecentUploadsResponse>(
      {
        url: `/campaigns/view/${campaignId}/check_recently_uploaded`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Dismiss completed results without deleting or cancelling active upload work.
   * @summary Close Recently Uploaded Candidates
   */
  const candidatesCloseRecentlyUploadedCandidates = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CloseRecentUploadsResponse>>
  ) => {
    return axiosInstance<CloseRecentUploadsResponse>(
      {
        url: `/campaigns/view/${campaignId}/close_recently_uploaded`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Restart a candidate through the current journey, including journeys without AI.
   * @summary Reissue Interview
   */
  const candidatesReissueInterview = (
    candidateCampaignId: string,
    options?: SecondParameter<typeof axiosInstance<ReissueInterviewResponse>>
  ) => {
    return axiosInstance<ReissueInterviewResponse>(
      {
        url: `/candidate/${candidateCampaignId}/reissue_interview`,
        method: 'POST',
      },
      options
    );
  };
  /**
 * Reissue interviews for one chunk of candidates by candidate_id + campaign_id.

Looks up the current active candidate_campaign_id fresh from the DB for each candidate,
so the caller never needs to track potentially stale candidate_campaign_ids. The frontend
splits large selections into small chunks so each request finishes quickly; the CAS claim
inside reissue_single_interview makes concurrent duplicates harmless.
 * @summary Bulk Reissue Interview
 */
  const candidatesBulkReissueInterview = (
    bulkReissueInterviewPayload: BulkReissueInterviewPayload,
    options?: SecondParameter<
      typeof axiosInstance<BulkReissueInterviewResponse>
    >
  ) => {
    return axiosInstance<BulkReissueInterviewResponse>(
      {
        url: `/candidates/reissue_interview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkReissueInterviewPayload,
      },
      options
    );
  };
  /**
   * Send a resume-review, other-interview or cooling-down candidate to the AI interview.
   * @summary Proceed To Interview Disqualified Or Other Interview Candidate
   */
  const candidatesProceedToInterviewDisqualifiedOrOtherInterviewCandidate = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<ProceedToInterviewResponse>>
  ) => {
    return axiosInstance<ProceedToInterviewResponse>(
      {
        url: `/candidate/${candidateId}/campaign/${campaignId}/proceed_to_interview`,
        method: 'POST',
      },
      options
    );
  };
  /**
 * Progress one or more candidates to AI interview by candidate_id + campaign_id.

Eligible stages match the single-candidate proceed_to_interview endpoint (any resume-review
stage, OTHER_INTERVIEW, COOLING_DOWN, or legacy OTHER_INTERVIEW call status).
Ineligible candidates are reported per-id without failing the whole request.
 * @summary Bulk Proceed To Interview
 */
  const candidatesBulkProceedToInterview = (
    bulkProceedToInterviewPayload: BulkProceedToInterviewPayload,
    options?: SecondParameter<
      typeof axiosInstance<BulkProceedToInterviewResponse>
    >
  ) => {
    return axiosInstance<BulkProceedToInterviewResponse>(
      {
        url: `/candidates/proceed_to_interview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkProceedToInterviewPayload,
      },
      options
    );
  };
  /**
   * Submit a request to reissue an expired interview
   * @summary Request Interview Reissue
   */
  const candidatesRequestInterviewReissue = (
    candidateId: string,
    callId: string,
    interviewReissueRequestPayload: InterviewReissueRequestPayload,
    options?: SecondParameter<
      typeof axiosInstance<InterviewReissueRequestResponse>
    >
  ) => {
    return axiosInstance<InterviewReissueRequestResponse>(
      {
        url: `/web_call/candidate/${candidateId}/call/${callId}/request_reissue`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: interviewReissueRequestPayload,
      },
      options
    );
  };
  /**
   * Approve a request to reissue an interview
   * @summary Approve Interview Reissue
   */
  const candidatesApproveInterviewReissue = (
    candidateId: string,
    callId: string,
    options?: SecondParameter<typeof axiosInstance<ApproveReissueResponse>>
  ) => {
    return axiosInstance<ApproveReissueResponse>(
      {
        url: `/candidate/${candidateId}/call/${callId}/approve_reissue`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Reject a request to reissue an interview
   * @summary Reject Interview Reissue
   */
  const candidatesRejectInterviewReissue = (
    candidateId: string,
    callId: string,
    options?: SecondParameter<typeof axiosInstance<RejectReissueResponse>>
  ) => {
    return axiosInstance<RejectReissueResponse>(
      {
        url: `/candidate/${candidateId}/call/${callId}/reject_reissue`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * @summary Save Candidate Comment
   */
  const candidatesSaveCandidateComment = (
    candidateId: string,
    campaignId: string,
    commentRequest: CommentRequest,
    options?: SecondParameter<
      typeof axiosInstance<SavedCandidateCommentResponse>
    >
  ) => {
    return axiosInstance<SavedCandidateCommentResponse>(
      {
        url: `/candidate/${candidateId}/comments/${campaignId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: commentRequest,
      },
      options
    );
  };
  /**
   * @summary Get Candidate Comments
   */
  const candidatesGetCandidateComments = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateCampaignCommentView[]>
    >
  ) => {
    return axiosInstance<CandidateCampaignCommentView[]>(
      {
        url: `/candidate/${candidateId}/comments/${campaignId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Update Candidate Comment
   */
  const candidatesUpdateCandidateComment = (
    candidateId: string,
    campaignId: string,
    commentId: string,
    updateCommentRequest: UpdateCommentRequest,
    options?: SecondParameter<typeof axiosInstance<CommentActionResponse>>
  ) => {
    return axiosInstance<CommentActionResponse>(
      {
        url: `/candidate/${candidateId}/comments/${campaignId}/${commentId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCommentRequest,
      },
      options
    );
  };
  /**
   * @summary Delete Candidate Comment
   */
  const candidatesDeleteCandidateComment = (
    candidateId: string,
    campaignId: string,
    commentId: string,
    options?: SecondParameter<typeof axiosInstance<CommentActionResponse>>
  ) => {
    return axiosInstance<CommentActionResponse>(
      {
        url: `/candidate/${candidateId}/comments/${campaignId}/${commentId}`,
        method: 'DELETE',
      },
      options
    );
  };
  /**
   * @summary Get Candidate Comments Count
   */
  const candidatesGetCandidateCommentsCount = (
    candidateId: string,
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CommentCountResponse>>
  ) => {
    return axiosInstance<CommentCountResponse>(
      {
        url: `/candidate/${candidateId}/comments/${campaignId}/count`,
        method: 'GET',
      },
      options
    );
  };
  return {
    candidatesUpdateCandidateCampaignUserReviewed,
    candidatesMarkChangesUnreviewed,
    candidatesGetCallDetails,
    candidatesGetResumeUrl,
    candidatesPauseCandidate,
    candidatesResumeCandidate,
    candidatesRemoveCandidate,
    candidatesPrepareChatContextEndpoint,
    candidatesCandidateTranscriptChat,
    candidatesMultiCandidateChatWithTranscript,
    candidatesScheduleNextInterviewOverSms,
    candidatesSendSmsToCandidate,
    candidatesUpdateCandidateView,
    candidatesGetCandidateCallDetails,
    candidatesGetCandidateCallAvailability,
    candidatesGetCandidateCallHistory,
    candidatesGetCandidateCallReview,
    candidatesGetCandidateCallRecommendations,
    candidatesGetCandidateCallSections,
    candidatesGetCandidatePriorInterviews,
    candidatesGetCandidateSmsDetails,
    candidatesGetCandidateCampaignFeedback,
    candidatesCandidateCampaignFeedback,
    candidatesGetCandidateCampaignAccess,
    candidatesGetTranscriptSharingContext,
    candidatesSetCandidateCampaignAccess,
    candidatesTranslateTranscript,
    candidatesCandidatesByIdentifier,
    candidatesGetSubmittalReport,
    candidatesUpdateSubmittalReport,
    candidatesAddContactsPreview,
    candidatesExtractResumeContactFields,
    candidatesAddContacts,
    candidatesUploadContactsToJobsPreview,
    candidatesUploadContactsToJobs,
    candidatesAddSingleContact,
    candidatesInternalAddCandidate,
    candidatesUploadCandidateResumesPreview,
    candidatesCreateBulkResumeImport,
    candidatesCompleteBulkResumeImportUpload,
    candidatesGetBulkResumeImport,
    candidatesListBulkResumeImportItems,
    candidatesPreviewBulkResumeImport,
    candidatesUploadCandidateCsv,
    candidatesCheckRecentlyUploadedCandidates,
    candidatesCloseRecentlyUploadedCandidates,
    candidatesReissueInterview,
    candidatesBulkReissueInterview,
    candidatesProceedToInterviewDisqualifiedOrOtherInterviewCandidate,
    candidatesBulkProceedToInterview,
    candidatesRequestInterviewReissue,
    candidatesApproveInterviewReissue,
    candidatesRejectInterviewReissue,
    candidatesSaveCandidateComment,
    candidatesGetCandidateComments,
    candidatesUpdateCandidateComment,
    candidatesDeleteCandidateComment,
    candidatesGetCandidateCommentsCount,
  };
};
export type CandidatesUpdateCandidateCampaignUserReviewedResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesUpdateCandidateCampaignUserReviewed']
    >
  >
>;
export type CandidatesMarkChangesUnreviewedResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesMarkChangesUnreviewed']
    >
  >
>;
export type CandidatesGetCallDetailsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesGetCallDetails']>
  >
>;
export type CandidatesGetResumeUrlResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesGetResumeUrl']>
  >
>;
export type CandidatesPauseCandidateResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesPauseCandidate']>
  >
>;
export type CandidatesResumeCandidateResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesResumeCandidate']>
  >
>;
export type CandidatesRemoveCandidateResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesRemoveCandidate']>
  >
>;
export type CandidatesPrepareChatContextEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesPrepareChatContextEndpoint']
    >
  >
>;
export type CandidatesCandidateTranscriptChatResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesCandidateTranscriptChat']
    >
  >
>;
export type CandidatesMultiCandidateChatWithTranscriptResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesMultiCandidateChatWithTranscript']
    >
  >
>;
export type CandidatesScheduleNextInterviewOverSmsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesScheduleNextInterviewOverSms']
    >
  >
>;
export type CandidatesSendSmsToCandidateResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesSendSmsToCandidate']>
  >
>;
export type CandidatesUpdateCandidateViewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesUpdateCandidateView']
    >
  >
>;
export type CandidatesGetCandidateCallDetailsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCallDetails']
    >
  >
>;
export type CandidatesGetCandidateCallAvailabilityResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCallAvailability']
    >
  >
>;
export type CandidatesGetCandidateCallHistoryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCallHistory']
    >
  >
>;
export type CandidatesGetCandidateCallReviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCallReview']
    >
  >
>;
export type CandidatesGetCandidateCallRecommendationsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesGetCandidateCallRecommendations']
    >
  >
>;
export type CandidatesGetCandidateCallSectionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCallSections']
    >
  >
>;
export type CandidatesGetCandidatePriorInterviewsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidatePriorInterviews']
    >
  >
>;
export type CandidatesGetCandidateSmsDetailsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateSmsDetails']
    >
  >
>;
export type CandidatesGetCandidateCampaignFeedbackResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCampaignFeedback']
    >
  >
>;
export type CandidatesCandidateCampaignFeedbackResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesCandidateCampaignFeedback']
    >
  >
>;
export type CandidatesGetCandidateCampaignAccessResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCampaignAccess']
    >
  >
>;
export type CandidatesGetTranscriptSharingContextResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetTranscriptSharingContext']
    >
  >
>;
export type CandidatesSetCandidateCampaignAccessResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesSetCandidateCampaignAccess']
    >
  >
>;
export type CandidatesTranslateTranscriptResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesTranslateTranscript']
    >
  >
>;
export type CandidatesCandidatesByIdentifierResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesCandidatesByIdentifier']
    >
  >
>;
export type CandidatesGetSubmittalReportResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesGetSubmittalReport']>
  >
>;
export type CandidatesUpdateSubmittalReportResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesUpdateSubmittalReport']
    >
  >
>;
export type CandidatesAddContactsPreviewResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesAddContactsPreview']>
  >
>;
export type CandidatesExtractResumeContactFieldsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesExtractResumeContactFields']
    >
  >
>;
export type CandidatesAddContactsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCandidates>['candidatesAddContacts']>>
>;
export type CandidatesUploadContactsToJobsPreviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesUploadContactsToJobsPreview']
    >
  >
>;
export type CandidatesUploadContactsToJobsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesUploadContactsToJobs']
    >
  >
>;
export type CandidatesAddSingleContactResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesAddSingleContact']>
  >
>;
export type CandidatesInternalAddCandidateResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesInternalAddCandidate']
    >
  >
>;
export type CandidatesUploadCandidateResumesPreviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesUploadCandidateResumesPreview']
    >
  >
>;
export type CandidatesCreateBulkResumeImportResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesCreateBulkResumeImport']
    >
  >
>;
export type CandidatesCompleteBulkResumeImportUploadResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesCompleteBulkResumeImportUpload']
    >
  >
>;
export type CandidatesGetBulkResumeImportResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetBulkResumeImport']
    >
  >
>;
export type CandidatesListBulkResumeImportItemsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesListBulkResumeImportItems']
    >
  >
>;
export type CandidatesPreviewBulkResumeImportResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesPreviewBulkResumeImport']
    >
  >
>;
export type CandidatesUploadCandidateCsvResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesUploadCandidateCsv']>
  >
>;
export type CandidatesCheckRecentlyUploadedCandidatesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesCheckRecentlyUploadedCandidates']
    >
  >
>;
export type CandidatesCloseRecentlyUploadedCandidatesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCandidates
      >['candidatesCloseRecentlyUploadedCandidates']
    >
  >
>;
export type CandidatesReissueInterviewResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCandidates>['candidatesReissueInterview']>
  >
>;
export type CandidatesBulkReissueInterviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesBulkReissueInterview']
    >
  >
>;
export type CandidatesProceedToInterviewDisqualifiedOrOtherInterviewCandidateResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getCandidates
        >['candidatesProceedToInterviewDisqualifiedOrOtherInterviewCandidate']
      >
    >
  >;
export type CandidatesBulkProceedToInterviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesBulkProceedToInterview']
    >
  >
>;
export type CandidatesRequestInterviewReissueResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesRequestInterviewReissue']
    >
  >
>;
export type CandidatesApproveInterviewReissueResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesApproveInterviewReissue']
    >
  >
>;
export type CandidatesRejectInterviewReissueResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesRejectInterviewReissue']
    >
  >
>;
export type CandidatesSaveCandidateCommentResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesSaveCandidateComment']
    >
  >
>;
export type CandidatesGetCandidateCommentsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateComments']
    >
  >
>;
export type CandidatesUpdateCandidateCommentResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesUpdateCandidateComment']
    >
  >
>;
export type CandidatesDeleteCandidateCommentResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesDeleteCandidateComment']
    >
  >
>;
export type CandidatesGetCandidateCommentsCountResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCandidates>['candidatesGetCandidateCommentsCount']
    >
  >
>;
